export enum PatientInfoVisibility {
	VISIBLE = 'visible',
	VISIBLE_COLLAPSED = 'visibleCollapsed',
	DISABLED = 'disabled'
}
